<template>
  <div>
    <v-form ref="form">
      <v-container>
        <v-layout wrap>
          <v-flex md3 sm12>
            <v-text-field
              v-model="data.name"
              append-icon="edit"
              :label="$t('common.name')"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex md3 sm12>
            <v-text-field
              v-model="data.street_name"
              append-icon="edit"
              :label="$t('maps.landmarkEditor.streetName')"
              :rules="[rules.required]"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex md3 sm12>
            <v-text-field
              v-model="data.street_number"
              append-icon="edit"
              :label="$t('maps.landmarkEditor.streetNumber')"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex md3 sm12>
            <v-select
              :label="$t('maps.landmarkEditor.selectCity')"
              :items="location_clusters"
              item-text="title"
              item-value="id"
              :rules="[required]"
              v-model="data.location_cluster_id"
            />

            
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md1>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="save"
              :loading="loading"
              >{{ $t("common.save") }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <div id="map"></div>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

export default {
  name: "LandmarkEditor",
  title() {
    return this.$t("maps.landmarkEditor.title");
  },
  data() {
    return {
      mode: "add", // or edit
      id: null,
      map: null,
      location_clusters:[],
      loading: false,
      answer: null,
      center: null,
      marker: null,
      data: {
        name: null,
      },
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.center = this.api.mapBox.center;
    this.marker = new Mapbox.Marker({ draggable: true });
    this.marker.setLngLat(this.api.mapBox.center);
    if (this.$route.params.id !== undefined) {
      this.mode = "edit";
      this.id = this.$route.params.id;
      this.getData();
    } else {
      this.mode = "add";
      this.loadMap();
    }
    this.axios.get(`${this.api.ACTIONS.LOCATION_CLUSTER}?perPage=100`)
                .then(res => this.location_clusters = res.data.data.data)
                .catch(err => console.log(err.message));
  },
  methods: {
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.marker.addTo(this.map);
    },
    getData() {
      this.axios
        .get(this.api.ACTIONS.LANDMARKS + `/${this.id}`)
        .then(({ data }) => {
          const { name, centroid, street_name, street_number ,location_cluster_id} = data.data;
          this.marker.setLngLat(centroid.coordinates);
          this.loadMap();
          this.data.name = name;
          this.data.street_number = street_number;
          this.data.street_name = street_name;
          this.data.location_cluster_id = location_cluster_id;
        });
    },

    reset() {
      this.data.name = null;
    },
    save() {
      if (!this.loading && this.$refs.form.validate()) {
        this.loading = true;
        this.data.landmark_type = "NORMAL";
        const url =
          this.mode === "add"
            ? this.api.ACTIONS.LANDMARKS
            : this.api.ACTIONS.LANDMARKS + "/" + this.id;
        (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
          centroid: {
            type: "Point",
            coordinates: this.marker.getLngLat().toArray(),
          },
          ...this.data,
        })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("maps.landmarkEditor.saved"), "green");
            this.mode === "add" ? this.reset() : null;
          })
          .catch(() => window.getApp.$emit("SHOW_TOAST", this.$t("maps.landmarkEditor.notSaved"), "red"))
          .finally(() => (this.loading = false));
      }
    },
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("maps.landmarkEditor.requiredRule"),
        number: (value) => isFinite(value) || this.$t("maps.landmarkEditor.mustBeNumber"),
      };
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 720px;
}
</style>
